import { render } from "./VabeneTraiteurPage.vue?vue&type=template&id=abbbec9a&ts=true"
import script from "./VabeneTraiteurPage.vue?vue&type=script&lang=ts"
export * from "./VabeneTraiteurPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__